import { triggerHostMessageChangeCallProvider } from '../triggerHostMessage/triggerHostMessageChangeCallProvider';
export default function handleChangeCallProvider(data) {
  triggerHostMessageChangeCallProvider(data);
}